import { TCommonError } from '@models/common';
import {
  TBulkUpdateInventoryStoreSessionStatusReq,
  TBulkUpdateInventoryStoreSessionStatusRes,
  TInventoryStoreSession,
  TInventoryStoreSessionStatusCounts,
  TUpdateInventoryStoreSessionStatusReq,
} from '@models/inventoryStoreSession';
import { TAxiosResponse } from 'types';
import { axiosInstance } from './axiosInstance';

/**
 * Service layer for t_inventory_store_sessions CRUD + status workflow (VAMS_PC_004 [承認/差し戻し]).
 */
const inventoryStoreSessionApi = {
  /** PUT /api/v1/inventory-store-sessions/{id}/status — 承認 (APPROVED) / 差し戻し (RETURNED). */
  updateStatus: async (
    id: string,
    payload: TUpdateInventoryStoreSessionStatusReq
  ) => {
    const response: TAxiosResponse<TInventoryStoreSession, TCommonError> =
      await axiosInstance.put(
        `/api/v1/inventory-store-sessions/${id}/status`,
        payload
      );
    return response;
  },

  /** GET /api/v1/inventory-store-sessions/by-session-store — 店舗 cụ thể (not 全て). */
  getBySessionAndStore: async (sessionCode: string, storeId: string) => {
    const response: TAxiosResponse<TInventoryStoreSession, TCommonError> =
      await axiosInstance.get(
        '/api/v1/inventory-store-sessions/by-session-store',
        { params: { sessionCode, storeId } }
      );
    return response;
  },

  /** GET /api/v1/inventory-store-sessions/status-counts — 店舗=全て eligibility check. */
  getStatusCounts: async (sessionCode: string) => {
    const response: TAxiosResponse<
      TInventoryStoreSessionStatusCounts,
      TCommonError
    > = await axiosInstance.get(
      '/api/v1/inventory-store-sessions/status-counts',
      { params: { sessionCode } }
    );
    return response;
  },

  /** PUT /api/v1/inventory-store-sessions/bulk-status — 店舗=全て 承認/差し戻し hàng loạt. */
  bulkUpdateStatus: async (
    payload: TBulkUpdateInventoryStoreSessionStatusReq
  ) => {
    const response: TAxiosResponse<
      TBulkUpdateInventoryStoreSessionStatusRes,
      TCommonError
    > = await axiosInstance.put(
      '/api/v1/inventory-store-sessions/bulk-status',
      payload
    );
    return response;
  },
};

export { inventoryStoreSessionApi };
